export enum PlanType {
  Individual = 1,
  Senior = 2,
  Spouse = 3,
  Family = 4,
  Group = 5,
}
